import { combineReducers } from 'redux';

import combinedResultsFlightsInline from './combinedResultsFlightsInline';
import * as fromCombinedResultsFlightsInline from './combinedResultsFlightsInline';
import currentAdvertIds from './currentAdvertIds';
import * as fromCurrentAdvertIds from './currentAdvertIds';

import type { CombinedResultsFlightsInlineAdvertById } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/combinedResultsFlightsInline';
import type { CurrentAdvertIdsState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entityCollections/currentAdvertIds';
import type { CombinedResultsAdvertsState } from '@web-platform/shared-universal-types/src/redux/state/shared/adverts';

const combinedResultsAdvertsReducer = combineReducers<CombinedResultsAdvertsState>({
  combinedResultsFlightsInline,
  currentAdvertIds,
});

export const INITIAL_STATE: CombinedResultsAdvertsState = combinedResultsAdvertsReducer(undefined, {
  type: '@@INIT',
});

export default combinedResultsAdvertsReducer;

// Base selectors
export const getAllCombinedResultsFlightsInlineAdverts = (
  state: CombinedResultsAdvertsState,
): CombinedResultsFlightsInlineAdvertById =>
  fromCombinedResultsFlightsInline.getAll(state.combinedResultsFlightsInline);

export const getCombinedResultsFlightsInlineAdvert = (
  state: CombinedResultsAdvertsState,
  id: string,
) => fromCombinedResultsFlightsInline.get(state.combinedResultsFlightsInline, id);

export const getCurrentAdvertIds = (state: CombinedResultsAdvertsState): CurrentAdvertIdsState =>
  fromCurrentAdvertIds.getAll(state.currentAdvertIds);
